import {matchPath} from 'react-router-dom';
import {
  CAMPAIGN_CREATORS_BREADCRUMB_ROUTES,
  CAMPAIGN_ASSETS_BREADCRUMB_ROUTES,
  CAMPAIGN_BREADCRUMB_ROUTES,
  CREATOR_BREADCRUMB_ROUTES,
  LISTS_BREADCRUMB_ROUTES,
  OFF_PLATFORM_BREADCRUMB_ROUTES,
} from './breadcrumbRouteDefinitions';
import type {BreadcrumbRoute} from './breadcrumbRouteTypes';

/**
 * All campaign breadcrumb routes (creators + assets + fallback).
 *
 * Order matters: more specific patterns must come before broader wildcards.
 */
export const ALL_CAMPAIGN_BREADCRUMB_ROUTES: BreadcrumbRoute[] = [
  ...CAMPAIGN_CREATORS_BREADCRUMB_ROUTES,
  ...CAMPAIGN_ASSETS_BREADCRUMB_ROUTES,
  ...CAMPAIGN_BREADCRUMB_ROUTES,
];

/**
 * Aggregated breadcrumb routes from all domains.
 *
 * Order matters: more specific patterns must come before broader wildcards so
 * that `matchBreadcrumbRoute` picks the right entry.
 */
const ALL_BREADCRUMB_ROUTES: BreadcrumbRoute[] = [
  ...ALL_CAMPAIGN_BREADCRUMB_ROUTES,
  ...OFF_PLATFORM_BREADCRUMB_ROUTES,
  ...CREATOR_BREADCRUMB_ROUTES,
  ...LISTS_BREADCRUMB_ROUTES,
];

/**
 * Returns the first matching breadcrumb route for `pathname`, along with the
 * extracted URL params. Returns `null` if no route matches.
 */
export function matchBreadcrumbRoute(pathname: string) {
  return ALL_BREADCRUMB_ROUTES.reduce<{
    route: BreadcrumbRoute;
    params: Record<string, string>;
  } | null>((acc, route) => {
    if (acc) {
      return acc;
    }
    const match = matchPath(route.path, pathname);
    return match
      ? {route, params: match.params as Record<string, string>}
      : null;
  }, null);
}
